import React from 'react'

function Footer() {
  return (
    <nav className="navbar is-black" id="desktop-foot"> 
    </nav>
  )
}

export default Footer